import { render, staticRenderFns } from "./miniprogramFooter.vue?vue&type=template&id=c9a5b8e6&scoped=true"
import script from "./miniprogramFooter.vue?vue&type=script&lang=js"
export * from "./miniprogramFooter.vue?vue&type=script&lang=js"
import style0 from "./miniprogramFooter.vue?vue&type=style&index=0&id=c9a5b8e6&prod&lang=postcss&scoped=true"
import style1 from "./miniprogramFooter.vue?vue&type=style&index=1&id=c9a5b8e6&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a5b8e6",
  null
  
)

export default component.exports